import { jwtDecode } from "jwt-decode";

const tokenExpiration = (token: string) => {
  const { exp }: { exp: number } = jwtDecode(token);
  return new Date(exp * 1000);
};

export default tokenExpiration;
